// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__c8WSO","top":"styles_top__23VJh","left":"styles_left__2BJF-","description":"styles_description__1Kc0K"};